import printConfig from '../../../print-config.json'
import { generatePath } from 'react-router-dom'
import ChooseTechnical from '../present/ChooseTechnical'
import getData from '../../../functions/getData'
import { PROGRAM_ATTRIBUTES } from '../../../constants/state'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../../../hoc/toJS'

const mapStateToProps = state => ({
    attributes: getData(state, PROGRAM_ATTRIBUTES)
})

const ChooseTechnicalContainer = ({match, goBackPath, attributes, altGoBackPath}) => {
    const { cinemaId, printType, printFormat, landscape, week, printPk } = match.params
    const { formats } = printConfig.routes[printType]
    const backPath = printType === 'showcasePreviewMovie' ? altGoBackPath : goBackPath
    const closePagePath = generatePath(backPath, match.params)

    return <ChooseTechnical
        cinemaId={cinemaId}
        printType={printType} 
        printID={printFormat} 
        printPk={printPk}
        week={week}
        landscape={landscape}
        attributes={attributes[cinemaId]}
        closePagePath={closePagePath}
    />
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(ChooseTechnicalContainer)